function ChatTypingMessage({ usertype = "userA" }) {
    return (
        <div className={`loadMessage ${usertype}`}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
  }
  
  export default ChatTypingMessage;
  